import { Url, URLS } from '@wix/da-url';
import { ModalType } from '../Modals/redux/types';
var submitMenuItems = [
    {
        type: 'deviation',
        label: 'siteHeader.deviation',
        link: Url.buildFromPath(URLS.SUBMIT),
        showDaProtect: true,
    },
    {
        type: 'status',
        label: 'siteHeader.statusUpdate',
        verificationAction: 'submitstatus',
        modalType: ModalType.STATUS_UPDATE,
    },
    {
        type: 'journal',
        label: 'siteHeader.journal',
        verificationAction: 'submitjournal',
        modalType: ModalType.JOURNAL,
    },
    {
        type: 'literature',
        label: 'siteHeader.literature',
        modalType: ModalType.LITERATURE,
    },
    {
        type: 'commission',
        label: 'siteHeader.commission',
        verificationAction: 'submitcommission',
        modalType: ModalType.COMMISSION,
        modalOptions: {
            params: { redirectOnSubmit: true },
        },
    },
    {
        type: 'poll',
        label: 'siteHeader.poll',
        verificationAction: 'submitpoll',
        modalType: ModalType.POLL_EDIT,
    },
    {
        type: 'tier',
        label: 'siteHeader.tier',
        link: URLS.ROOT,
        modalType: ModalType.TIER_EDIT,
        modalOptions: {
            wrapInModal: false,
        },
        isNew: true,
    },
];
export var desktopSubmitMenuItems = submitMenuItems;
// mobile has fewer items in different order
export var mobileSubmitMenuItems = [
    'deviation',
    'status',
    'poll',
    'commission',
].map(function (type) { return submitMenuItems.find(function (item) { return item.type === type; }); });
export var submitButtonMenuItem = {
    type: 'submitbutton',
    link: Url.buildFromPath(URLS.SUBMIT),
};
//# sourceMappingURL=constants.js.map